import { formatDateString } from "utils/date";

export enum ApiCardTransactionCustomerState {
  pending = "pending",
  declined = "declined",
  posted = "posted",
  repaid = "repaid",
  partially_repaid = "partially_repaid",
  expired = "expired",
  manuallyExpired = "manually_expired",
}

export enum ApiCardTransactionSource {
  ewa = "ewa",
  checking = "checking",
}

export interface ApiCardTransaction {
  id: string;
  date: string;
  amount: number;
  customerState: ApiCardTransactionCustomerState;
  merchantName: string;
  merchantCategory: string;
  source: ApiCardTransactionSource;
}

const dateReducer = (acc, transaction) => {
  const date = formatDateString(transaction.date, "numericLong");
  if (acc.length > 0 && date === acc[acc.length - 1]?.date) {
    acc[acc.length - 1].transactions.push(transaction);
  } else {
    acc.push({
      date,
      transactions: [transaction],
    });
  }
  return acc;
};

interface TransactionsByDate {
  date: string;
  transactions: ApiCardTransaction[];
}

export const getTransactionsByDate = (
  transactions: ApiCardTransaction[] = []
) => {
  const sortedTransactions = transactions.reduce(
    dateReducer,
    []
  ) as TransactionsByDate[];

  return sortedTransactions;
};
